// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-hideoverflow_container__3nniu"};